import styled, { css } from 'styled-components';

import { Container } from '@/components/Container';
import { Grid } from '@/components/Grid';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Container)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      padding-inline: 0;
    }
  `}
`;
export const HitsWrapper = styled(Grid)<{ col: number; itemCount: number }>`
  display: grid;
  grid-auto-rows: 1fr;
  width: 100%;

  ${({ col, itemCount, theme }) => css`
    grid-template-columns: repeat(
      ${itemCount === 1 ? 'auto-fit' : 'auto-fill'},
      calc((100% - ${theme.spacing(1 * 1.5)}) / 2)
    );
    justify-content: ${itemCount === 1 ? 'center' : ''};
    gap: ${theme.spacing(1.5)};
    background-color: ${theme.colors.white};

    ${theme.media.md.up} {
      justify-content: center;
      grid-template-columns: repeat(
        auto-fit,
        calc((100% - ${theme.spacing((col - 1) * 2.5)}) / ${col})
      );
      gap: ${theme.spacing(2.5)};
    }
  `}
`;

export const BuckleNotIncluded = styled(Typography)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p3};
    color: ${theme.colors.secondaryGrey};
    margin-top: ${theme.spacing(0.5)};
  `}
`;
